import './ChartLegend.css';

export interface LegendItem {
  label: string;
  color: string;
  marker: 'line' | 'box';
}

export interface ChartLegendProps {
  items: LegendItem[];
}

const ChartLegend = ({ items }: ChartLegendProps): JSX.Element => {
  return (
    <div className="chart-legend">
      {items.map((item) => (
        <div className="chart-legend__item" key={item.label}>
          <span
            className={`chart-legend__marker chart-legend__marker--${item.marker}`}
            style={{ backgroundColor: item.color }}
          />
          <span className="chart-legend__label">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default ChartLegend;
